import React from 'react';
import { get } from 'lodash';
import HeaderRenderer from '../HeaderRenderer';

export const getHeaderRenderer = (filterable, col) => props =>
  <HeaderRenderer filterable={filterable} column={col} headerProps={props} />;

export const getFormatter = col => props =>
  <div className="cell">{col.getValue?.(props.row) || get(props.row, col.key, '')}</div>;
